import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const Blog = () => {
  const featuredPost = {
    date: 'January 20, 2024',
    title: '10 Tips for a Successful First Date',
    excerpt: 'First dates can be nerve-wracking, but with the right preparation and mindset, you can make a great impression. Here are our top tips for making your first date memorable.',
    category: 'Dating Tips',
    image: '/images/couples/romantic-couple-4.jpg'
  };

  const blogPosts = [
    {
      date: 'January 15, 2024',
      title: 'How to Write the Perfect Dating Profile',
      excerpt: 'Your profile is your first impression. Learn how to showcase your personality authentically.',
      category: 'Profile Tips'
    },
    {
      date: 'January 10, 2024',
      title: 'The Art of Online Conversation',
      excerpt: 'Master the art of engaging conversations that lead to meaningful connections.',
      category: 'Communication'
    },
    {
      date: 'January 5, 2024',
      title: 'Staying Safe While Dating Online',
      excerpt: 'Essential safety tips every online dater should know before meeting in person.',
      category: 'Safety'
    },
    {
      date: 'December 28, 2023',
      title: 'Long Distance Relationships: Making It Work',
      excerpt: 'Practical advice for maintaining a strong connection across the miles.',
      category: 'Relationships'
    },
    {
      date: 'December 20, 2023',
      title: 'Recognizing Red Flags in Online Dating',
      excerpt: 'Learn to spot warning signs early and protect yourself from unhealthy relationships.',
      category: 'Safety'
    },
    {
      date: 'December 15, 2023',
      title: 'Building Confidence for Dating Success',
      excerpt: 'Boost your self-confidence and approach dating with a positive mindset.',
      category: 'Self-Improvement'
    }
  ];

  const categories = ['All', 'Dating Tips', 'Profile Tips', 'Communication', 'Safety', 'Relationships', 'Self-Improvement'];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">Paperdate Blog</h1>
          <p className="lead text-muted">
            Expert advice, dating tips, and relationship insights to help you find and nurture meaningful connections.
          </p>
        </Col>
      </Row>

      {/* Featured Post */}
      <Row className="mb-5">
        <Col>
          <Card className="border-0 shadow-sm overflow-hidden">
            <Row className="g-0">
              <Col md={6}>
                <div 
                  className="h-100" 
                  style={{ 
                    backgroundImage: `url(${featuredPost.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '300px'
                  }}
                />
              </Col>
              <Col md={6}>
                <Card.Body className="p-4 p-lg-5 d-flex flex-column justify-content-center h-100">
                  <span className="badge bg-primary mb-3" style={{ width: 'fit-content' }}>
                    {featuredPost.category}
                  </span>
                  <small className="text-muted">{featuredPost.date}</small>
                  <h2 className="fw-bold mt-2 mb-3">{featuredPost.title}</h2>
                  <p className="text-muted mb-4">{featuredPost.excerpt}</p>
                  <Button variant="primary" style={{ width: 'fit-content' }}>
                    Read Article
                  </Button>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      {/* Categories */}
      <Row className="mb-4">
        <Col>
          <div className="d-flex flex-wrap gap-2">
            {categories.map((category, index) => (
              <Button 
                key={index} 
                variant={index === 0 ? 'primary' : 'outline-primary'} 
                size="sm"
              >
                {category}
              </Button>
            ))}
          </div>
        </Col>
      </Row>

      {/* Blog Posts Grid */}
      <Row>
        {blogPosts.map((post, index) => (
          <Col lg={4} md={6} key={index} className="mb-4">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body className="p-4">
                <span className="badge bg-dark mb-3">{post.category}</span>
                <small className="text-muted d-block mb-2">{post.date}</small>
                <h5 className="fw-bold mb-3">{post.title}</h5>
                <p className="text-muted mb-3">{post.excerpt}</p>
                <Button variant="link" className="p-0 text-primary">
                  Read More <i className="bi bi-arrow-right"></i>
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Load More */}
      <Row className="mt-4">
        <Col className="text-center">
          <Button variant="outline-primary" size="lg">
            Load More Articles
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Blog;

